import { render, staticRenderFns } from "./Semiology.vue?vue&type=template&id=712d07a0&scoped=true&"
import script from "./Semiology.vue?vue&type=script&lang=js&"
export * from "./Semiology.vue?vue&type=script&lang=js&"
import style0 from "./Semiology.vue?vue&type=style&index=0&id=712d07a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d07a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
